import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { RequestTokenService } from "../../request-token.service";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { RegisterAccess } from "../../../app/shared/Entities/RegisterAccess";
import { AlocaUsuarioResponsavelSignature } from "../../../app/shared/Signature/AlocaUsuarioResponsavelSignature";
import { CriarCompromissoSignature } from "../../../app/shared/Signature/CriarCompromissoSignature";
import { AtualizarCompromissoSignature } from "../../../app/shared/Signature/AtualizarCompromissoSignature";

const API_URL = `${environment.apiUrl}v1/Analista`;

@Injectable({
  providedIn: 'root'
})

export class AnalistaService {

  constructor(private http: HttpClient,
    private requestToken: RequestTokenService
  ) {}

  private handleError(error: any): Observable<never> {
    console.error('An error occurred', error);
    return throwError(error);
  }

  public GetAnalista(): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/GetAnalista`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetAnalistaTodos(): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/GetAnalistaTodos`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetAnalistaBusca(): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/GetAnalistaBusca`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public RegistraAcesso(signature: RegisterAccess): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/RegistraAcesso`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetTipoAnalista(): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/GetTipoAnalista`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public SalvarLegendaTipoUsuario(legendas: Array<{ Id: string; Legenda: string }>): Observable<any> {
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/SalvarLegendaTipoUsuario`, legendas, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetPopupEmployee(employeeId: string): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${API_URL}/GetPopupEmployee?employeeId=${employeeId}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public AlocaUsuarioResponsavel(signature: AlocaUsuarioResponsavelSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.post<any>(`${API_URL}/AlocaUsuarioResponsavel`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetCompromissos(employeeId?: string, dataInicio?: Date, dataFim?: Date): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    let params = new URLSearchParams();
    if (employeeId) params.append('employeeId', employeeId);
    if (dataInicio) params.append('dataInicio', dataInicio.toISOString());
    if (dataFim) params.append('dataFim', dataFim.toISOString());

    const queryString = params.toString();
    const url = queryString ? `${API_URL}/GetCompromissos?${queryString}` : `${API_URL}/GetCompromissos`;

    return this.http.get<any>(url, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public CriarCompromisso(signature: CriarCompromissoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.post<any>(`${API_URL}/CriarCompromisso`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public AtualizarCompromisso(signature: AtualizarCompromissoSignature): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.put<any>(`${API_URL}/AtualizarCompromisso`, signature, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public DeletarCompromisso(id: string): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.delete<any>(`${API_URL}/DeletarCompromisso/${id}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetAnalistaPorTipo(tipoUsuario: number): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetAnalistaPorTipo/${tipoUsuario}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetListaAnalistaGerenteExecutivo(gerenteExecutivoId: string): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true
    };

    return this.http.get<any>(`${API_URL}/GetListaAnalistaGerenteExecutivo/${gerenteExecutivoId}`, options)
    .pipe(
      catchError(this.handleError)
    )
  }

  public GetUsuariosOperacional(): Observable<any>{
    const options = {
      headers: this.requestToken.createAuthorizationHeader(),
      withCredentials: true // Garante que cookies/autenticação sejam enviados
    };

    return this.http.get<any>(`${environment.apiOperacionalUrl}Analista/GetUsuariosOperacional`, options)
    .pipe(
      catchError(this.handleError)
    )
  }
}
